import api, { API_VERSIONS } from "@/config/api";
import { SMART_DEBRIEF_API } from "@/config/const";
import { recoverTokenInfo } from "../utils/recoverTokenInfo";
import { AxiosError } from "axios";

export const getRecordingAudio = async (recordingId: string): Promise<string | AxiosError | undefined> => {
  try {
    const initialToken = recoverTokenInfo();
    if (!initialToken) return "";

    const res = await api.get<{ token: string }>(`/${API_VERSIONS.v0}/file/${recordingId}/generaterecordingtoken`, {
      headers: {
        Accept: "*/*",
        Authorization: `Bearer ${initialToken}`,
      },
    });

    if (!res.data?.token) return "";

    return new URL(`/${API_VERSIONS.v0}/file/streamrecording?token=${res.data.token}`, SMART_DEBRIEF_API).toString();
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      throw error;
    }
  }
};